<template>

    <v-overlay v-if="showPopup">
      <h3 class="text-pdsPrimary text-xl font-bold my-2">Handtekening toevoegen</h3>
      <v-paragraph class="text-primary-default text-base my-2">
        Om uw account compleet te maken, hebben wij nog uw handtekening nodig. Deze kunt u hier eenmalig invoeren,
        daarna wordt hij automatisch ingevoerd als u gevraagd wordt iets te ondertekenen. Zet hieronder uw handtekening
        en klik op 'Handtekening opslaan'
      </v-paragraph>
      <div class="flex flex-row">
        <div>
          <v-input-digital-signature
            @save-signature="saveSignature"
            @undo-signature="undoSignature"
          />
        </div>
      </div>
    </v-overlay>
</template>

<script>
import axios from 'axios';
import VInputDigitalSignature from '@/components/shared/form/simple/InputDigitalSignature';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';

export default {
  name: 'VPrescriberSignature',
  components: {
    VInputDigitalSignature
  },
  setup() {
    const store = useStore();
    const setSignatureSaved = (value) => store.commit('prescriber/setSignatureSaved', value);
    const showPopup = ref(false);

    const saveSignature = (data, uploadType) => {
      let formData = { PrescriberUpload: null , PrescriberSignature: null, SignatureType: "" }; ;
      if (uploadType == 'Upload') {
        return axios.post('Registration/SignatureUpload', data).then((response) => {
          formData.PrescriberUpload = response.data 
          formData.SignatureType = "Upload" ; 
          uploadSignature(formData)
        })
        }
      else {
      data = data.substr(22, data.length);
       formData.PrescriberSignature = data ;
       uploadSignature(formData)
      }
    };
    const uploadSignature = async (signature) => {
       await axios
        .post('UserSignature/SaveUserSignature', signature, {
          headers: {
            Accept: 'application/pdf'
          }
        });
      setSignatureSaved(true);
      showPopup.value = false
    }

    onMounted(() => {
      axios.get('UserSignature/GetUserSignatureConfiguration').then((response) => {
        setSignatureSaved(!response.data.UserSignatureConfiguration.SignatureIsMissing);
        showPopup.value = response.data.UserSignatureConfiguration.SignatureIsMissing;
      });
    });

    return {
      showPopup,
      setSignatureSaved,
      saveSignature
    };
  }
};
</script>
